<div class="-oneX-container">
  <div class="-oneX-heading--h2">Payments</div>
  <br>
  <div class="-oneX-row -oneX-justify-content-center">
    <div class="-oneX-col-10">
      <table id="payment-details" class="-oneX-table--standard" aria-label="Standard table">
        <thead class="-oneX-thead">
          <tr class="-oneX-tr">
            <th class="-oneX-th--col">Payment #</th>
            <th class="-oneX-th--col">Date Issued</th>
            <th class="-oneX-th--col">Paid To</th>
            <th class="-oneX-th--col">Payment Amount </th>
            <th class="-oneX-th--col">Type of Payment</th>
            <th class="-oneX-th--col">Payment Status</th>
            <th class="-oneX-th--col">Bill Reference Number</th>
          </tr>
        </thead>
        <tbody class="-oneX-tbody">
          <tr class="-oneX-tr" *ngFor="let payment of paymentsArray; let i=index ;">
            <td class="-oneX-td">{{paymentsArray[i].paymentNumber}}</td>
            <td class="-oneX-td">{{paymentsArray[i].paymentDate}}</td>
            <td class="-oneX-td">{{paymentsArray[i].payee}}</td>
            <td class="-oneX-td">{{paymentsArray[i].amount}}</td>
            <td class="-oneX-td">{{paymentsArray[i].method}}</td>
            <td class="-oneX-td">{{paymentsArray[i].status}}</td>
            <td class="-oneX-td">{{paymentsArray[i].reference_num}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>